export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";